import { errorCodes } from '@/constants'

export const checkIsErrorPage = (pageSlug?: string): boolean => Object.values(errorCodes)?.some(code => pageSlug?.substring(1,4) == code)
